import { useEffect, useRef, useState } from 'react'

export const useValueFlash = (value) => {
  const [isFlashing, setIsFlashing] = useState(false)
  const prevRef = useRef(undefined)

  useEffect(() => {
    function check() {
      if (prevRef.current === undefined) {
        prevRef.current = value
        return
      }
      if (prevRef.current !== value) {
        prevRef.current = value
        setIsFlashing(true)
        const timer = setTimeout(() => setIsFlashing(false), 1200)
        return () => clearTimeout(timer)
      }
    }
    return check()
  }, [value])

  return isFlashing
}
